import React, { Component, Fragment } from 'react'
import CustomTable from '../../../../../../elements/Table/CustomTable'
import { get, map, round, sum } from 'lodash'
import { moneyColumn, numVal } from '../../../../../../modules/Utils'
import DateTimeCell from '../../../../../../elements/Table/Cells/DateTimeCell'
import MoneyCell from '../../../../../../elements/Table/Cells/MoneyCell'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { Button } from 'antd'

const CheckboxTable = checkboxHOC(CustomTable)

class BillLinesList extends Component {
  columns = [
    {
      Header: 'No',
      accessor: 'no',
    },
    {
      Header: 'Name',
      accessor: 'name',
    },
    { Header: 'Date', accessor: 'date', Cell: DateTimeCell },

    {
      Header: 'Units',
      accessor: 'unit',
      Cell: MoneyCell,
    },
    {
      Header: 'Vat Amount',
      accessor: 'vatAmount',
      Cell: MoneyCell,
    },
    {
      Header: 'Paid',
      accessor: 'paid',
      Cell: MoneyCell,
    },
    {
      Header: 'Operation',
      accessor: '_id',
      Cell: ({ value, original }) => {
        return (
          <div className="editable-row-operations">
            <a onClick={() => this.props.remove(original[this.props.keyAttr])}>Remove</a>
          </div>
        )
      },
    },
  ]

  render() {
    const {
      billLines,
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
      removeSelectedLines,
      selection,
      tableRef,
    } = this.props
    const checkboxProps = {
      selectType: 'checkbox',
      selectAll,
      isSelected,
      toggleSelection,
      toggleAll,
    }

    return (
      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        ExtraButtons={() => (
          <Fragment>
            <Button
              style={{ float: 'left', marginRight: 10 }}
              onClick={removeSelectedLines}
              size={'small'}
              disabled={selection.length === 0}
              icon={'file-protect'}>
              Remove Selected Lines
            </Button>
            <span>
              Total Amount :{' '}
              <strong>{moneyColumn(round(sum(this.props.billLines.map((d) => numVal(d, 'paid')))))}</strong>
            </span>
          </Fragment>
        )}
        hide={{ refresh: true }}
        data={billLines}
        columns={this.columns}
      />
    )
  }
}

BillLinesList.propTypes = {}
BillLinesList.defaultProps = {}

export default BillLinesList
